import {get} from "../utils";
import {fixup_server_url} from "./locate-mdx-proxy-url";
import {RESULT_TYPE_NEOFAX} from "../pages/NeoFaxPediatricsPage/common/constants";

export function getNeofaxPediatricsWordwheelPromise({result_type = RESULT_TYPE_NEOFAX, login_page}){
    const proxy_url = fixup_server_url(`/api/v1/${result_type}/monograph/documents/list`);

    const cookie_session = get(login_page, 'mdxAuthenticationJson.Set-Cookie', '')

    //return a Promise
    return fetch(proxy_url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authCookie': cookie_session
            },
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
        })
}

export function getNeoPedMonographPromise({result_type = RESULT_TYPE_NEOFAX, documentId, login_page}){
    const proxy_url = fixup_server_url(`/api/v1/${result_type}/monograph/htmldocuments/${documentId}`);
    const cookie_session = get(login_page, 'mdxAuthenticationJson.Set-Cookie', '')

    return fetch(proxy_url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authCookie': cookie_session
            },
            method: 'GET',
            credentials: 'include',
            mode: 'cors'
        })
}

export function getEnteralFormulaDetailsPromise({
                                                    result_type = RESULT_TYPE_NEOFAX,
                                                    docId="",
                                                    displayFormat="both",
                                                    login_page}){
    const proxy_url = fixup_server_url(`/api/v1/${result_type}/enteralformula/nutrient/${docId}?measurement=${displayFormat}`);
    const cookie_session = get(login_page, 'mdxAuthenticationJson.Set-Cookie', '')

    //return a Promise
    return fetch(proxy_url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authCookie': cookie_session
            },
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
        })
}


export function getEnteralFormulasListPromise({result_type = RESULT_TYPE_NEOFAX , login_page}){
    const proxy_url = fixup_server_url(`/api/v1/${result_type}/enteralformula/list`);
    const cookie_session = get(login_page, 'mdxAuthenticationJson.Set-Cookie', '')

    //return a Promise
    return fetch(proxy_url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authCookie': cookie_session
            },
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
        })
}

export function getEnteralFormulaProductNotesPromise({result_type = RESULT_TYPE_NEOFAX, docIds, login_page}){
    const encoded_doc_ids = encodeURI(docIds.join(","));
    const proxy_url = fixup_server_url(`/api/v1/${result_type}/enteralformula/productnotes?docIds=${encoded_doc_ids}`);

    const cookie_session = get(login_page, 'mdxAuthenticationJson.Set-Cookie', '')

    return fetch(proxy_url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authCookie': cookie_session
            },
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
        })
}